import './index.css'
import cn from 'clsx'

import React from 'react'
import InlineSVG from 'svg-inline-react'
import BlockDragWrapper from 'containers/dnd/campaign-editor/block-drag-wrapper'
import type { BlockConfig } from '../helpers'

const EditorBlockList = ({
  list,
}: {
  list: (BlockConfig | null | undefined)[]
}): React.ReactElement<'div'> => (
  <div className="editor-block-list">
    {list.map((block, blockIndex) => {
      if (!block)
        return (
          <div
            className="editor-block-list__block"
            key={`block-${blockIndex}`}
          />
        )
      const { text, svg, type, imageClass, textClass } = block
      return (
        <BlockDragWrapper type={type} key={`block-${blockIndex}`}>
          <div className="editor-block-list__block">
            <InlineSVG
              src={svg}
              className={cn('editor-block-list__block__image', imageClass)}
            />
            <div className={cn('editor-block-list__block__text', textClass)}>
              {text}
            </div>
          </div>
        </BlockDragWrapper>
      )
    })}
  </div>
)

export default EditorBlockList
